import { FC } from 'react';

import { rem, Tooltip, UserAddSolid } from '@bonusly/design-system';

import { Chip } from '../../components/common/chip/chip';
import User from '../../types/user';

interface UserChipProps {
	user: User;
}

export const UserChip: FC<UserChipProps> = ({ user }) => (
	<Tooltip label={user.display_name}>
		<Chip aria-label={user.display_name} display="inline-flex" role="figure" size="xs" verticalAlign="top" width={rem(28)}>
			<UserAddSolid paddingInline={0} size="sm" />
		</Chip>
	</Tooltip>
);
